import './App.css';
import React, { useEffect, useState } from 'react';
import Home from './components/Home';
import SuccessPayment from './components/SuccessPayment';
import FailedPayment  from './components/FailedPayment';
import AbortedPayment from './components/AbortedPayment';
import { BrowserRouter as Router, Routes, Route, useSearchParams, useNavigate} from 'react-router-dom';
import axios from 'axios';
import PaymentLayout from './components/layout/PaymentLayout';
import { pushDataLayerEvent } from './gtm';

/**
 * Webpay return url handler.
 * author:d3m0n10q3
 */
const RetrievePayment = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);
  const token = searchParams.get('token_ws') || searchParams.get('TBK_TOKEN');

  useEffect(() => {
    let ignore = false;
    const controller = new AbortController();
    setError(false);
    if (!token) {
      setError(true);
      return () => controller.abort();
    }
    axios.get(window.env.BACKEND_API_BASE_URL + 'api/tusmultas/payment/get-tbk-reponse/' + encodeURIComponent(token), { signal: controller.signal, timeout: 30000 })
      .then(({ data }) => {
        if (ignore) return;
        const routes = { Aprobado: '/success', Rechazado: '/failure', Cancelado: '/aborted' };
        const parsedAmount = data.amount == null
          ? undefined
          : Number(String(data.amount).replace(/\./g, ''));
        const amount = Number.isSafeInteger(parsedAmount) ? parsedAmount : undefined;
        if (routes[data.status]) {
          if (data.status === 'Aprobado') {
            pushDataLayerEvent('pago_completado', {
              value: amount,
              currency: 'CLP',
              transaction_id: token,
              email: data.email,
            });
          }
          navigate(routes[data.status], { replace: true, state: { name: data.name, email: data.email, amount } });
        } else {
          setError(true);
        }
      })
      .catch(() => { if (!ignore) setError(true); });
    return () => { ignore = true; controller.abort(); };
  }, [token, navigate, attempt]);

  return (
    <PaymentLayout title="Resultado del pago" subtitle="Tu tranquilidad, en cada paso">
      <section className="payment-card verification-card" aria-live="polite">
        {error ? <>
          <h2>No pudimos verificar tu pago</h2>
          <p>No podemos confirmar el resultado de esta transacción. Antes de realizar otro pago, verifica el cargo con tu banco o contáctanos.</p>
          <div className="result-actions">
            {token && <button className="button" onClick={() => setAttempt(attempt + 1)}>Volver a verificar</button>}
            <a className="text-link" href="mailto:libera@tusmultas.cl">Contactar a Tusmultas.cl</a>
          </div>
        </> : <>
          <span className="spinner" aria-hidden="true" />
          <h2>Estamos verificando tu pago</h2>
          <p>Espera un momento mientras recibimos la respuesta de Transbank. No cierres esta ventana.</p>
        </>}
      </section>
    </PaymentLayout>
  );
};


class App extends React.Component {
  render() {
    return (
       <Router>
            <Routes>
                 <Route exact path='/'                        element={< Home />}></Route>
                 <Route exact path='/success'                 element={< SuccessPayment />}></Route>
                 <Route exact path='/failure'                 element={< FailedPayment />}></Route>
                 <Route exact path='/aborted'                 element={< AbortedPayment />}></Route>
                 <Route exact path="/retrieve-payment"        element={< RetrievePayment />}></Route>
            </Routes>
       </Router>
   );
  }
}

export default App;